import script from "./SeatingChartPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SeatingChartPage.vue?vue&type=script&setup=true&lang=js"

import "./SeatingChartPage.vue?vue&type=style&index=0&id=97772e9a&lang=css"

const __exports__ = script;

export default __exports__